import * as tslib_1 from "tslib";
import { OnDestroy } from '@angular/core';
import { fuseConfig } from 'app/fuse-config';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@ngx-translate/core";
import * as i2 from "@angular/common/http";
var FuseTranslationLoaderService = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {TranslateService} _translateService
     */
    function FuseTranslationLoaderService(_translateService, _http) {
        this._translateService = _translateService;
        this._http = _http;
        this.pageTranslationsLoaded = new BehaviorSubject(false);
        this.onLangChanged = new BehaviorSubject(false);
        this._fuseConfig = fuseConfig;
        this._unsubscribeAll = new Subject();
    }
    /**
     * Resolver
     *
     * @returns {Observable<any> | Promise<any> | any}
     */
    FuseTranslationLoaderService.prototype.resolve = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Promise.all([
                _this.getLastLang(),
                _this.getLanguages()
            ])
                .then(function () {
                resolve();
            })
                .catch(function (err) { return Promise.reject(err); })
                .then(function () {
            }, function (err) {
                // this._router.navigate(['/home']);
            });
        });
    };
    FuseTranslationLoaderService.prototype.processEmptyTranslations = function (object) {
        var newObject = {};
        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                if (typeof object[key] === 'object') {
                    newObject[key] = this.processEmptyTranslations(object[key]);
                }
                else if (typeof object[key] === 'string' && object[key] === '') {
                    // do not copy empty strings
                }
                else {
                    newObject[key] = object[key];
                }
            }
        }
        return newObject;
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    /**
     * Load translations
     *
     * @param {Locale} args
     */
    FuseTranslationLoaderService.prototype.loadTranslations = function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var locales = tslib_1.__spread(args);
        locales.forEach(function (locale) {
            // use setTranslation() with the third argument set to true
            // to append translations instead of replacing them
            _this._translateService.setTranslation(locale.lang, locale.data, true);
        });
    };
    /**
     * get translations
     *
     */
    FuseTranslationLoaderService.prototype.getTranslations = function (languageCode, categoryId) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._http.get(_this._fuseConfig.api.url + '/translator/site/get-by-category/' + languageCode + '/' + categoryId)
                .subscribe(function (response) {
                _this._translateService.setTranslation(languageCode, _this.processEmptyTranslations(response['data']), true);
                _this.pageTranslationsLoaded.next(true);
                resolve(true);
                setTimeout(function () {
                    _this._translateService.use(languageCode);
                }, 1000);
            }, reject);
        });
    };
    FuseTranslationLoaderService.prototype.getMultipleTranslationCategories = function (languageCode, categoriesId) {
        var _this = this;
        var params = {
            categories: categoriesId
        };
        return new Promise(function (resolve, reject) {
            _this._http.post(_this._fuseConfig.api.url + '/translator/site/get-by-categories/' + languageCode, params)
                .subscribe(function (response) {
                _this.pageTranslationsLoaded.next(true);
                resolve(true);
                _this._translateService.setTranslation(languageCode, _this.processEmptyTranslations(response['data']), true);
                setTimeout(function () {
                    _this._translateService.use(languageCode);
                }, 1000);
            }, reject);
        });
    };
    FuseTranslationLoaderService.prototype.getLastLang = function () {
        var _this = this;
        var lang = localStorage.getItem('lang');
        var langName = localStorage.getItem('langName');
        return new Promise(function (resolve, reject) {
            _this._http.get(_this._fuseConfig.api.url + '/translator/site/get-default-language')
                .pipe(takeUntil(_this._unsubscribeAll))
                .subscribe(function (response) {
                if ((!lang || lang === 'undefined') && (!langName || langName === 'undefined')) {
                    resolve(response['data']);
                }
                else {
                    resolve({ code: lang, name: langName });
                }
            }, reject);
        });
    };
    FuseTranslationLoaderService.prototype.setLastLang = function (lang) {
        localStorage.setItem('lang', lang.id);
        localStorage.setItem('langName', lang.title);
        this.onLangChanged.next(true);
    };
    /**
     * get languages
     *
     */
    FuseTranslationLoaderService.prototype.getLanguages = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._http.get(_this._fuseConfig.api.url + '/translator/site/get-languages')
                .pipe(takeUntil(_this._unsubscribeAll))
                .subscribe(function (response) {
                resolve(response['data']);
            }, reject);
        });
    };
    /**
     * Lifecycle hooks
     */
    FuseTranslationLoaderService.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    FuseTranslationLoaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FuseTranslationLoaderService_Factory() { return new FuseTranslationLoaderService(i0.ɵɵinject(i1.TranslateService), i0.ɵɵinject(i2.HttpClient)); }, token: FuseTranslationLoaderService, providedIn: "root" });
    return FuseTranslationLoaderService;
}());
export { FuseTranslationLoaderService };
